import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import {
  Box,
  Typography,
  Alert,
  Card,
  CardContent,
  Grid,
} from '@mui/material';

const Home = () => {
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [typeDistribution, setTypeDistribution] = useState({ Restaurant: 0, 'Food Court': 0, Hotel: 0 });
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'companies'));
        const companiesData = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const companyData = { id: doc.id, ...doc.data() }; // Includes code field
            const adminsSnapshot = await getDocs(collection(db, 'companies', doc.id, 'admins'));
            const admins = adminsSnapshot.docs.map(adminDoc => ({
              id: adminDoc.id,
              ...adminDoc.data(),
            }));
            return { ...companyData, admins };
          })
        );
        setTotalCompanies(companiesData.length);

        const typeCounts = companiesData.reduce((acc, company) => {
          const type = company.type || 'Unknown';
          acc[type] = (acc[type] || 0) + 1;
          return acc;
        }, { Restaurant: 0, 'Food Court': 0, Hotel: 0 });
        setTypeDistribution(typeCounts);
      } catch (err) {
        console.error('Error fetching companies:', err);
        setError('Failed to load company data. Check Firestore permissions or data.');
      }
    };
    fetchCompanies();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Software Admin Dashboard
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3} width={240}>
          <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Total Companies
              </Typography>
              <Typography variant="h4">{totalCompanies}</Typography>
            </CardContent>
          </Card>
        </Grid>
        {['Restaurant', 'Food Court', 'Hotel'].map((type) => (
          <Grid item xs={12} sm={6} md={3} key={type} width={240}>
            <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {type + (typeDistribution[type] !== 1 ? 's' : '')}
                </Typography>
                <Typography variant="h4">{typeDistribution[type]}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Home;